import { render, staticRenderFns } from "./detalleImportacionAdd.vue?vue&type=template&id=0df71545"
import script from "./detalleImportacionAdd.vue?vue&type=script&lang=js"
export * from "./detalleImportacionAdd.vue?vue&type=script&lang=js"
import style0 from "./detalleImportacionAdd.vue?vue&type=style&index=0&id=0df71545&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports